import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const OpenPositionCard = ({ data }) => {
  const beforeDate = new Date(`${data?.approvedDate}`);
  const today = new Date();
  const diffTime = Math.abs(today - beforeDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return (
    <>
      <div>
        <div className="openPositionCardText-m1">
          {data?.title || localStorage.getItem("title") || "NA"}
        </div>
        <div className="openPositionCardText-m2">
          {(() => {
            if (data?.type === "H") return "Full Time";
            else if (data?.type === "FL") return "Freelance";
            else if (data?.type === "C") return "Contract";
            else if (data?.type === "C2H") return "Contract to hire";
            // else if (data?.type === "FL") return "Full time";
            else return "N/A";
          })()}
        </div>
      </div>
      <div>
        <div className="openPositionCardText-m3">
          <div>
            <LocationOnIcon
              className="locationOnIcon"
              sx={{ color: "#165DFF" }}
            />
          </div>
          <div className="openPositionCardText-m3-text">{`${
            data?.city || "MILPITAS"
          }, ${data?.state || "California"}`}</div>
        </div>
        <div className="openPositionCardText-m3" style={{ paddingTop: "8px" }}>
          <div>
            <CalendarMonthIcon
              className="calendarMonthIcon"
              sx={{ color: "#165DFF" }}
            />
          </div>
          <div className="openPositionCardText-m3-text">
            Posted{" "}
            {(() => {
              if (diffDays <= 1) {
                return "Few hours ago";
              } else {
                return `${
                  diffDays > 1
                    ? diffDays > 60
                      ? "60"
                      : diffDays - 1
                    : diffDays
                } days ago`;
              }
            })()}{" "}
          </div>
        </div>
      </div>
    </>
  );
};

export default OpenPositionCard;
